module.exports = __webpack_public_path__ + "img/phone.1a4e1704.jpg";